
import { omit } from 'lodash'
import FLAG from '@/utils/flags/global'

// Initial state
export const initialState = {
    flags: {},
}

export const mutations = {
    CLEAN (state) {
        Object.assign(state, initialState)
    },
    SHOW_LOADING (state, { opacity = initialState.loading.opacity, text = initialState.loading.text }) {
        state.loading = { active: true, opacity, text }
    },
    HIDE_LOADING (state) {
        state.loading = initialState.loading
    },
    SET (state, { key, value }) {
        addFlag(state, key, value)
    },
    SET_UNDEFINED (state, key) {
        addFlag(state, key, FLAG.UNDEFINED)
    },
    SET_LOADING (state, key) {
        addFlag(state, key, FLAG.LOADING)
    },
    SET_SUCCESS (state, key) {
        addFlag(state, key, FLAG.SUCCESS)
    },
    SET_OK (state, key) {
        addFlag(state, key, FLAG.OK)
    },
    SET_ERROR (state, key) {
        addFlag(state, key, FLAG.ERROR)
    },
    SET_TRUE (state, key) {
        addFlag(state, key, FLAG.TRUE)
    },
    SET_FALSE (state, key) {
        addFlag(state, key, FLAG.FALSE)
    },
    REMOVE (state, key) {
        removeFlag(state, key)
    },
}

// HELPERS:
export function addFlag (state, key, value) {
    if (typeof state !== 'object') {
        // eslint-disable-next-line no-console
        console.warn('store.flags.addFlag : state is not valid', state)
        return
    }
    if (typeof state.flags !== 'object') {
        // eslint-disable-next-line no-console
        console.warn('store.flags.addFlag : state.flags is not valid', state.flags)
        return
    }
    state.flags = { ...state.flags, [key]: value }
}
export function removeFlag (state, key) {
    if (typeof state !== 'object') {
        // eslint-disable-next-line no-console
        console.warn('store.flags.removeFlag : state is not valid', state)
        return
    }
    if (typeof state.flags !== 'object') {
        // eslint-disable-next-line no-console
        console.warn('store.flags.removeFlag : state.flags is not valid', state.flags)
        return
    }
    state.flags = omit(state.flags, key)
}

export default {
    namespaced: true,
    state: {
        ...initialState,
    },
    mutations,
}
